<template>
      <div class="full-page">
    <div class="div-block">
      <h1 class="head-40">התחברות</h1>
      <p class="signin-txt">עוד אין לך חשבון? <router-link to="register" class="link">הרשם</router-link></p>
      <input v-on:keyup.13="submit()" type="email" class="text-field w-input" maxlength="256" name="email" data-name="email" v-model="email" placeholder="דוא״ל" id="email" required="">
      <input  v-on:keyup.13="submit()" type="password" class="text-field w-input" maxlength="256" name="password" data-name="password" v-model="password" placeholder="סיסמא" id="password" required=""><a v-on:click="submit()" href="#" class="button w-button">כניסה</a>
      <p class="error">{{error}}</p>
      <p class="signin-txt top-space"><router-link to="/forgot-password" class="link">שכחתי סיסמה</router-link></p>
    </div>
  </div>
</template>

<script>
export default {
    name:'login',
        data(){
        return {
      error:'',
      email:'',
      password:'',
      errorArray:{
        "auth/invalid-email":"כתובת מייל לא תקינה",
        "auth/wrong-password":"סיסמה שגויה",
        "auth/user-not-found":"לא נמצא חשבון בכתובת מייל זו"
      }
    }
        },
    mounted(){
      if (this.$parent.user){
          this.$router.push('/alternatives')
      }
    },
    methods:{
      submit(){
        firebase.auth().signInWithEmailAndPassword(this.email, this.password).then((e)=>{
            if (e){
                this.$router.push('/alternatives')
            }
        }).catch((error)=> {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          this.error = this.errorArray[error.code]
        })
      },
      enter(e){
          if (e.keyCode === 13){
              e.preventDefault();
              this.submit()
          }
      }
    }

}
</script>

<style scoped>
    full-page{
        background: white;
        z-index: 1001;
    }
</style>
